export class EbsTarget {
    'description';
    'tags';
    'volumeEncryptionKeyId';
    'encryptionKeyId';
    'availabilityZone';
    'volumeSettings';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "volumeEncryptionKeyId",
            "baseName": "volumeEncryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "VolumeSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EbsTarget.attributeTypeMap;
    }
    constructor() {
    }
}
